module.exports = __webpack_public_path__ + "img/Swift 1.a5d05996.svg";